import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Role'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
